module.exports = __webpack_public_path__ + "media/images/admin/icons/home-f981ee9d6dcfecf8c081d9efc60e5d95.svg";